import { Formik, Form } from 'formik';
import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';

// Shared
import SubmitButton from '@atoms/SubmitButton';
import TextInput from '@atoms/TextInput';

// Functionality
import { LoadingContext } from '@context/LoadingProvider';
import { insertMember } from '@general/api/memberAPI';
import { LabelLarge } from '@react/styledComponents';
import { EventRegistrationContext } from '../EventRegistrationProvider';
import { getLoginPath } from '../../../../helpers/url.helpers';
import NewPassword from '../../../_molecules/NewPassword';
import { PasswordChangeContext } from '@context/PasswordChangeProvider';

const EventRegistrationNameFields = () => {
    const { registrationEmail } = useContext(EventRegistrationContext);
    const { setIsLoading } = useContext(LoadingContext);
    const { code } = useParams();
    const { newPassword, confirmPassword, setNewPasswordError } = useContext(PasswordChangeContext);
    const history = useHistory();
    const [ firstName, setFirstName ] = useState('');
    const [ lastName, setLastName ] = useState('');


    const createAccount = async () => {
        setIsLoading(true);
        if (newPassword !== confirmPassword) {
            setNewPasswordError('Passwords do not match');
            setIsLoading(false);
            return;
        }
        try {
            const memberResponse = await insertMember(
                {
                    first_name: firstName,
                    last_name: lastName,
                    email: registrationEmail,
                    password: newPassword,
                },
                false
            );

            if (memberResponse?.error === 'invalid password') {
                setNewPasswordError(
                    [memberResponse.message.warning, memberResponse.message.suggestions.join(' ')].join(' ')
                );
                setIsLoading(false);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setIsLoading(false);
            if (error.response.data.data.error_type === 'breached_password') {
                setNewPasswordError(
                    'The password you have chosen is not considered secure. Please choose a different password.'
                );
            } else {
                setNewPasswordError(
                    'Please choose a different password.'
                );
            }
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    firstName: '',
                    lastName: '',
                }}
                onSubmit={() => {}}
                // validationSchema={Yup.object().shape({
                //     firstName: Yup.string()
                //         .required('Required')
                //         .min(2, 'Miminum 2 characters.'),
                //     lastName: Yup.string()
                //         .required('Required')
                //         .min(2, 'Miminum 2 characters.'),
                // })}
            >
                {({ errors, dirty, isSubmitting, isValid }) => {
                    return (
                        <>
                            <Form>
                                <LabelLarge className="block mb-1rem">
                                    We can't find your email in our system. Please provide your first, last name and a
                                    password to create a new account.
                                </LabelLarge>

                                <TextInput
                                    name="firstName"
                                    placeholder="First Name"
                                    required
                                    type="text"
                                    value={firstName}
                                    onChange={e => setFirstName(e.target.value)}
                                    style={{ maxWidth: '400px' }}
                                />
                                <TextInput
                                    name="lastName"
                                    placeholder="Last Name"
                                    required
                                    type="text"
                                    value={lastName}
                                    onChange={e => setLastName(e.target.value)}
                                    style={{ maxWidth: '400px' }}
                                />
                            </Form>

                            <div style={{ marginTop: '2rem', maxWidth: '400px', marginBottom: '6rem' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                    <NewPassword
                                        email={registrationEmail}
                                        onUpdate={createAccount}
                                        buttonText="Create an Account"
                                    />
                                </div>
                            </div>
                        </>
                    );
                }}
            </Formik>
        </div>
    );
};

EventRegistrationNameFields.propTypes = {
    //
};

export default EventRegistrationNameFields;
